import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { TabIds } from "features/CenterContent/RoleContent/useTabsForRole";
import { HistoryDetail } from "features/History/HistoryDetail/HistoryDetail";
import { FC } from "react";
import {
  generatePath,
  Navigate,
  useNavigate,
  useParams,
} from "react-router-dom";
import * as ROUTES from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";

export const HistoryDetailRoute: FC = () => {
  const navigate = useNavigate();
  const { role } = useDropsRole();
  const { eventUuidParam, eventTypeParam } = useParams<{
    eventTypeParam?: string;
    eventUuidParam?: string;
  }>();

  const oversiktPath = generatePath(ROUTES.LANDING, {
    roleIdParam: role,
    tabIdParam: TabIds.HISTORY,
  });

  if (!eventUuidParam) {
    return <Navigate to={oversiktPath} replace />;
  }

  const handleSetEventDetailUUID = (uuid: string | null) => {
    if (!uuid) {
      navigate(oversiktPath);
      return;
    }

    navigate(
      generatePath(ROUTES.DETAIL, {
        eventTypeParam: eventTypeParam ?? "unknown",
        eventUuidParam: uuid,
      }),
    );
  };

  return (
    <>
      <TabsCenter />
      <HistoryDetail
        eventUuid={eventUuidParam}
        setEventDetailUUID={handleSetEventDetailUUID}
      />
    </>
  );
};
